import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ConfirmPasscodeRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ConfirmPasscodeResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const confirmPasscode = (request: ConfirmPasscodeRequest, options?: CashRequestOptions) =>
  post<ConfirmPasscodeRequest, ConfirmPasscodeResponse>('/2.0/cash/confirm-passcode', request, {
    ...options,
    rejectOnError: true,
  })
